import { omit } from 'lodash-es'

export const mergeWithStatistics = (surveyEntities, statisticsEntities) => {
    return surveyEntities.reduce((acc, surveyEntity) => {
        const statisticsEntity = statisticsEntities.find(e => e.id === surveyEntity.id)
        if (statisticsEntity !== undefined) {
            acc.push({ ...surveyEntity, statistics: omit(statisticsEntity, 'id') })
        }
        return acc
    }, [])
}

// convert a 1–5 scale to a 0–100 scale
export function likertResponseToPercentage(responseValue) {
    if (responseValue !== null) {
        return (responseValue - 1) * 25
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/utilities/statistics.js